// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"6b8f9909","453":"8625f1c0","667":"bef86698","943":"425a3cc0"}[chunkId] + ".chunk.js";
};